import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { Outlet } from "react-router-dom";

export default function ProtectedRoute({ role }) {
    const { user } = useContext(AuthContext);

    if (!user) return <Navigate to="/" />;

    if (role && user.role !== role) {
        return <Navigate to="/" />;
    }

    return <Outlet />;
}